import VueGtm from '@gtm-support/vue2-gtm';
import Vue from 'vue'
import appConfig from "@src/app.config.json";
import router from "@router/index";
import store from '@src/store'

// const AppGa = window.globalData.GA;

async function gtm() {
  await store.dispatch('global/fetchSetting')
    .then((res) => {
      const gtm = res.items.ga || ''
      // const gtm = 'GTM-T4RS3CJ'
      // console.log(gtm)
      if (gtm) {
        Vue.use(VueGtm, {
          // container id
          id: gtm,
          // enable track or not (optional)
          enabled: process.env.NODE_ENV === 'production',
          ignoredViews: ['404'],
          vueRouter: router,
          // display console logs debugs or not (optional)
          debug: false
        })
      }
    })

}
gtm()

